import { Component } from '@angular/core';

@Component({
  host: { 'class': 'fw-loading' },
  selector: 'fw-loading',
  styleUrls: ['./fw-loading.component.scss'],
  templateUrl: './fw-loading.component.html',
})
export class FwLoadingComponent { }
